import React from 'react';
import GraphButton from '../../GraphButton';

const PngBtn = ({ cy }) => {
  const png = () => {
    // debug-console.log('png:cy=', cy);
    const options = {
      output: 'blob', // Whether the output should be 'base64uri' (default), 'base64', 'blob', or 'blob-promise' (a promise that resolves to the blob is returned).
      bg: 'white', // The background colour of the image (transparent by default).
      full: true, // Whether to export the current viewport view (false, default) or the entire graph (true).
      // scale This value specifies a positive number that scales the size of the resultant image.
      // maxWidth Specifies the scale automatically in combination with maxHeight such that the resultant image is no wider than maxWidth.
      // maxHeight Specifies the scale automatically in combination with maxWidth such that the resultant image is no taller than maxHeight.
    };
    const png64 = cy.png(options);

    // put the png data in an img tag
    // document.querySelector('#png-eg').setAttribute('src', png64);
    saveFile('test.png', 'data:image/png', png64);
  };

  function saveFile(name, type, data) {
    if (data && navigator.msSaveBlob) return navigator.msSaveBlob(new Blob([data], { type }), name);
    const a = $("<a style='display: none;'/>");
    const url = window.URL.createObjectURL(new Blob([data], { type }));
    a.attr('href', url);
    a.attr('download', name);
    $('body').append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  return <GraphButton id="png" label="Ảnh" onClick={png} title="Tải ảnh về máy" />;
};

export default PngBtn;
